var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOptions}},_vm._l((5),function(i){return _c('swiper-slide',{key:i},[_vm._v("\n    Slide "+_vm._s(i)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }